





















import { SharedVariable } from '@core/model/SharedVariable'
import { ClientPolicyDto } from '@core/pages/CommissionModule/api'
import { PolicyIndividualDTO } from '@core/pages/new-business-register/api'
import { UIService } from '@core/services/UIService'
import { inject } from 'inversify-props'
import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import AddManualNbrDTO from '../../policy-list/AddManualNbrDTO'
import ILPSection from '../ILPSection.vue'
import ILPDetailSection from '../ILPDetailSection.vue'
import ViewPolicyPlaceHolderSection from '../ViewPolicyPlaceHolderSection.vue'
import { ClientPolicy } from '@core/pages/bsc/bscClasses'
import { ProductList } from '@core/pages/adminProductList/model/ProductList'
import { ilpProductTypes, isInclude } from '@master/model/common/ProductMeta'
import { IRiskRatingService } from '@master/services/IRiskRatingService'

const clientPolicyStore = namespace('ClientPolicyStore')
const kycFormStore = namespace('KYCFormStore')

@Component({
  components: {
    ILPSection,
    ILPDetailSection,
    ViewPolicyPlaceHolderSection
  }
})
export default class ILPPage extends Vue {
  @clientPolicyStore.State
  private policyInView: ClientPolicyDto

  @clientPolicyStore.State
  private policy: ClientPolicyDto

  @clientPolicyStore.State
  private subPolicies: ClientPolicyDto[]

  @clientPolicyStore.State
  private policyIndividuals: PolicyIndividualDTO[]

  @clientPolicyStore.State
  private frequencyOptions

  @clientPolicyStore.Action
  private removeSubPolicy

  @clientPolicyStore.Action
  private retrieveSubPolicies

  @clientPolicyStore.Action
  private saveSubPolicy

  @clientPolicyStore.Action
  private addNewSubPolicy

  @clientPolicyStore.Action
  private selectedPolicyInView

  // please refer to https://wenconsulting.atlassian.net/jira/software/c/projects/IFAM/issues/IFAM-1336
  // to get the function code
  @kycFormStore.Action
  private fetchAllActiveInactiveProducts

  @kycFormStore.State
  private productList: ProductList

  uiService: UIService

  @inject()
  private sharedVariable: SharedVariable

  @inject()
  private riskRatingService: IRiskRatingService

  async insertNewPolicy () {
    const isConfirm = await this.uiService.confirm.show({
      type: 'warning',
      message: 'Create a new ILP?'
    }) as boolean

    if (isConfirm) {
      const policyToAdd = new AddManualNbrDTO()
      policyToAdd.adviserOid = this.policy.adviserOid
      policyToAdd.mainNbrOid = this.policy.oid
      policyToAdd.clientOid = this.policy.clientOid
      policyToAdd.applicationDate = Date.now()
      policyToAdd.lineOfBusiness = 'fund' // Set this as a fund, so that it can be filtered
      const result = await this.addNewSubPolicy(policyToAdd)

      if (result) {
        await this.retrieveSubPolicies(this.policy.oid)
        await this.selectedPolicyInView(this.ilpSubPolcies[this.ilpSubPolcies.length - 1])
        this.uiService.alert.show({
          type: 'success',
          message: 'Successfully created transaction.'
        })
      }
    }
  }

  async viewPolicyDetails (policy: ClientPolicy) {
    this.selectedPolicyInView(policy)
  }

  async updateSubPolicy (policyToUpdate: ClientPolicyDto) {
    await this.saveSubPolicy(policyToUpdate)
  }

  get ilpSubPolcies () {
    return this.subPolicies.filter(policy => isInclude(ilpProductTypes, policy?.productTypeDetailed || '') || isInclude(ilpProductTypes, policy?.type || ''))
  }

  async removePolicy (oid: string) {
    await this.removeSubPolicy(oid)
  }

  async mounted () {
    this.uiService = this.sharedVariable.uiService
    this.selectedPolicyInView(null)
    await this.retrieveSubPolicies(this.policy.oid)
    await this.fetchAllActiveInactiveProducts()
  }

  get filteredFrequencyOptions () {
    return this.frequencyOptions.map(frequency => {
      return {
        label: frequency.value === 'Single' ? 'Lump Sum' : frequency.label,
        value: frequency.value
      }
    })
  }

  get productOptions () {
    const productMetadata = JSON.parse(this.policy.productMetadata)
    const issuerOid = this.getRawIssuerOid(productMetadata)
    return this.productList.retrieveInvestmentFundsVia(productMetadata?.productFamilyCode, issuerOid, []).map(rider => {
      return {
        label: rider.name,
        value: rider.oid
      }
    })
  }

  getRawIssuerOid (productMetadata) {
    // this is because some issuer oid is stored as 'issuer_oid' some is stored as 'issuerOid' or only 'issuer' (name only) due to old data
    // so we made a trick help to check on issuerOid (this should be latest version) => issuer_oid,
    // if both of them no exist, we can go to NBR overview -> to get the Principal
    return productMetadata?.issuerOid || productMetadata?.issuer_oid || this.policy.principal || ''
  }

  get riskRatingOptions () {
    return Object.keys(this.riskRatingService.riskRatingMap()).map(key => {
      return {
        label: this.riskRatingService.riskRatingMap()[key],
        value: key
      }
    })
  }
}
